export default __webpack_public_path__ + "static/media/Graph4.8ac3ec07.svg";